var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"disabled":!_vm.link,"to":_vm.link,"link":""},nativeOn:{"click":function($event){return _vm.callAction.apply(null, arguments)}}},[_c('v-list-item-icon',[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._t("icon")],2),_c('v-list-item-content',[_c('v-list-item-title',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }